import React, { useState } from 'react';
import { IonItem, IonLabel } from '@ionic/react';
import SectionCard from '@/components/SectionCard';
import type { SharingSetupDraft } from '@/modules/topic/upsert/types';
import type { SharingSetupProps } from './types';
import styles from './SharingSetupLink.module.css';

interface SharingSetupLinkProps {
  /** The type's `SharingSetup` step, injected by the per-type `EditForm`. */
  SharingSetup: React.FC<SharingSetupProps>;
  /** The edit form's draft that the setup edits. */
  draft: SharingSetupDraft;
}

/**
 * The "Sharing" card — a single chevron row that opens the per-type
 * `SharingSetup` step, where the author edits the form people fill in to write
 * messages about this topic. Each per-type `EditForm` renders it, on create and
 * edit alike; the form it edits belongs to the edit form's draft, sent with the
 * create or update.
 *
 * The row reads the same whether the topic still uses its type's default form
 * or one the author has edited: to the author it is simply this topic's sharing
 * form.
 */
const SharingSetupLink: React.FC<SharingSetupLinkProps> = ({
  SharingSetup,
  draft,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <SectionCard title="Sharing">
        <IonItem
          button
          detail
          lines="none"
          onClick={() => setIsOpen(true)}
          data-testid="customize-templates-link"
        >
          <IonLabel className={styles.label}>
            <h2>Edit sharing setup</h2>
            <p>
              Change the form people use to write messages about this topic.
            </p>
          </IonLabel>
        </IonItem>
      </SectionCard>
      <SharingSetup
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        draft={draft}
      />
    </>
  );
};

export default SharingSetupLink;
